import { PASS_PROPERTY, STEP_UP_PROPERTY } from "@constants/policy-step-up-constants";
import { FormattedTrustScoreRangeMap } from "@idw-types/formatted-trust-score-range";
import { styled } from '@mui/material/styles';
import { SliderValueLabelProps } from "@mui/material/Slider";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

const StepUpTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: 'yellow',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: 14
    },
    [`& .MuiTooltip-arrow`]: {
        color: 'yellow'
    }
}));

const PassTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: '#28A745',
        color: '#fff',
        fontSize: 14
    },
    [`& .MuiTooltip-arrow`]: {
        color: '#28A745'
    }
}));

type SliderLabelValueComponentProps = {
    stepUpMinPropertiesMap: FormattedTrustScoreRangeMap;
}

export const SliderLabelComponent = (props: SliderLabelValueComponentProps & SliderValueLabelProps): any => {
    const { children, value, open, stepUpMinPropertiesMap } = props;


    const getTrustScoreTooltip = (value: React.ReactNode) => {
        switch (value) {
            case stepUpMinPropertiesMap[STEP_UP_PROPERTY].value: {
                return (<StepUpTooltip
                    open={open}
                    enterTouchDelay={0}
                    placement="top"
                    title={`${stepUpMinPropertiesMap[STEP_UP_PROPERTY].label}: ${value}`}
                    arrow>
                    {children}
                </StepUpTooltip>);
            }

            case stepUpMinPropertiesMap[PASS_PROPERTY].value: {
                return (<PassTooltip
                    open={open}
                    enterTouchDelay={0}
                    placement="top"
                    title={`${stepUpMinPropertiesMap[PASS_PROPERTY].label}: ${value}`}
                    arrow>
                    {children}
                </PassTooltip>);
            }

            default: {
                return (<Tooltip
                    open={open}
                    enterTouchDelay={0}
                    placement="top"
                    title={`${stepUpMinPropertiesMap[PASS_PROPERTY].label}: ${value}`}
                    arrow>
                    {children}
                </Tooltip>);
            }
        }
    }

    return (<> {getTrustScoreTooltip(value)}</>);
};